import templateUrl from './workstationRequired.html'

/**
 * Workstation Required error route configuration.
 *
 * Routes that require an {@link ActiveWorkstation active workstation} to work will
 * redirect here if there is none.
 *
 * @namespace routes.WorkstationRequired
 * @type {TmrRoute}
 */
export const route = {
  name: 'workstationRequired',
  label: 'WORKSTATIONREQUIRED.TITLE',
  component: 'tmrWorkstationRequired',
  accessControl: [],
}

/**
 * Workstation Required error route component.
 *
 * @type {ngComponent}
 */
export const tmrWorkstationRequired = {
  ngType: 'component',
  templateUrl,
}
